import {useState, useEffect} from 'react'
import { getWordMetadataList } from '../../../../../../services/WordMetadataService'
import * as Sentry from '@sentry/browser';
import { logSentryException } from '../../../../../../services/util';

export default function useChangeOnePartWordMetadata({phraseMetaData, targetWord, originalWord}) {

    const [wordMetadata, setWordMetadata] = useState(null)
    const [subWordMetadata, setSubWordMetadata] = useState(null)
    const [exampleWordMetaData, setExampleWordMetaData] = useState(null)
    const [exampleSubWordMetaData, setSubExampleWordMetaData] = useState(null)
    const [loading, setLoading ] = useState(true)

    const [error, setError] = useState(null)

    useEffect(() => {
        if(phraseMetaData && targetWord){
            const wordsToFetch = [originalWord, targetWord];
            if(phraseMetaData.instructions && phraseMetaData.instructions.example) {
                wordsToFetch.push(phraseMetaData.instructions.example.originalWord);
                wordsToFetch.push(phraseMetaData.instructions.example.targetWord);
            }

            getWordMetadataList(wordsToFetch).then((list) => {
                setWordMetadata(list[0])
                setSubWordMetadata(list[1])
                if(list.length > 2) {
                    setExampleWordMetaData(list[2]);
                    setSubExampleWordMetaData(list[3]);
                }
                setLoading(false);
            }).catch((err) => {
                console.error("Change one part story missing word metadata", err)
                setError(err)
                setLoading(false);
                logSentryException(new Error('ChangeOnePart word metadata missing'), 'Change one part story missing word metadata');
                // also send this error to sentry for monitoring
            })
        }
    }, [phraseMetaData, targetWord, originalWord])

    return {
        wordMetadata,
        subWordMetadata,
        exampleWordMetaData,
        exampleSubWordMetaData,
        error,
        loading,
    }
}